<template>
    <div>
        <h6 class="mb-2">
            {{ name }}

            <a href="javascript:void(0);" @click="showDialog = true" style="margin-left: 10px; font-size: 13px;">Mostra</a>
        </h6>

        <p v-if="shortDescription" v-html="shortDescription"></p>

        <p v-if="doubleOptIn == 1" class="mb-0 text-muted" style="font-size: 13px;">
            * In caso di accettazione, riceverai una email per confermare la tua scelta.
        </p>


        <div v-if="required" class="mt-2">
            <input :checked="checkboxValue" @click="onCheckboxClick" type="checkbox" :name="'agreements[' + id +']'" value="si" :id="'agreements[' + id +']'">
            <label :for="'agreements[' + id +']'" class="ml-1 mb-0">{{ checkboxText }} <span>*</span></label>
        </div>
        <div v-else class="mt-2">
            <label class="d-block">{{ checkboxText }}</label>

            <input type="radio" :name="'agreements[' + id +']'" value="si" :id="'agreementY'+id" v-model="radioValue" @click="onRadioClick">
            <label :for="'agreementY'+id" class="mb-0">Si</label>

            <input class="ml-3" type="radio" :name="'agreements[' + id +']'" value="no" :id="'agreementN'+id" v-model="radioValue" @click="onRadioClick">
            <label :for="'agreementN'+id" class="mb-0">No</label>
        </div>


        <Dialog :visible.sync="showDialog" :closable="!required" modal :style="{ width: '90vw', maxWidth:'900px' }" :id="'agreement-dialog-'+id" @show="onShowDialog" @hide="onHideDialog">
            <template #header>
		        <h3>{{ name }}</h3>
	        </template>
            <div v-html="longDescription"></div>
            <template #footer>
                <div class="pt-3">
                    <button type="button" class="btn btn-reject" @click="onRejectAgreement" :disabled="disableButtons">Rifiuta</button>
                    <button type="button" class="btn btn-accept" @click="onAcceptAgreement" :disabled="disableButtons">Accetta</button>
                </div>
            </template>
        </Dialog>

    </div>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    props: ['id', 'name', 'shortDescription', 'longDescription', 'checkboxText', 'required', 'doubleOptIn', 'old'],
    components: {
        Dialog,
    },
    data() {
        return {
            checkboxValue: false,
            radioValue: null,
            agreement: {},
            showDialog: false,
            dialogContentEl: null,
            disableButtons: true,
        };
    },
    methods: {
        onCheckboxClick(e) {
            e.preventDefault();
            this.showDialog = true;
        },
        onRadioClick() {
            this.$emit('answered', { id: this.id, answered: true });
        },
        onAcceptAgreement() {
            if (this.required) {
                this.checkboxValue = true;
                this.$emit('answered', { id: this.id, answered: true });
            } else {
                this.radioValue = 'si';
                this.$emit('answered', { id: this.id, answered: true });
            }
            this.showDialog = false;
        },
        onRejectAgreement() {
            if (this.required) {
                this.checkboxValue = false;
                this.$emit('answered', { id: this.id, answered: false });
            } else {
                this.radioValue = 'no';
                this.$emit('answered', { id: this.id, answered: true });
            }

            this.showDialog = false;
        },

        onShowDialog() {
            if (this.required) {
                this.disableButtons = true;
                const dialog = document.querySelector('#agreement-dialog-' + this.id);
                if (dialog) {
                    this.dialogContentEl = dialog.querySelector('.p-dialog-content');

                    this.dialogContentEl.addEventListener('scroll', this.onScrollDialog);
                }
            } else {
                this.disableButtons = false;
            }
        },
        onScrollDialog() {
            if (Math.abs(this.dialogContentEl.scrollTop - (this.dialogContentEl.scrollHeight - this.dialogContentEl.offsetHeight)) <= 50) {
                this.disableButtons = false;
            }
        },
        onHideDialog() {
            if (this.agreement.required) {
                this.dialogContentEl.removeEventListener('scroll',this.onScrollDialog);
            }
        },
    },
    mounted() {
        if (this.old) {
            if (this.required && this.old === 'si') {
                this.checkboxValue = true;
                this.$emit('answered', { id: this.id, answered: true });
            } else {
                if (this.old === 'si') {
                    this.radioValue = 'si';
                } else {
                    this.radioValue = 'no';
                }
                this.$emit('answered', { id: this.id, answered: true });
            }
        }

    },
};
</script>

<style lang="scss" scoped>
label > span {
    margin-left: 4px;
    color: #e23e1d;
}
</style>
